<template>
  <div style="background: #ffffff;padding: 20px;box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);">
    <div style="border-bottom: 1px solid #e4e4e4;font-weight: 600;padding-bottom: 10px"><span>流程设置</span></div>
    <div style="background: #ffffff;padding: 10px 20px 20px 20px;">
      <div v-for="item in activeData" :key="item.id">
        <div style="display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #e4e4e4;">
          <div class="flexAlign" style="width: 20%"><img src="~assets/images/common/icon_user.png" width="50px"/><span
              style="padding-left: 10px">{{ item.flowName }}</span></div>
          <div class="flexAlign" style="flex-direction: column;width: 20%">
            <span>最后修改人：</span><span>{{ item.updateUser }}</span></div>
          <div class="flexAlign" style="flex-direction: column;width: 40%">
            <span>最后更新：</span><span>{{ item.updateTime | timeFormatDate }}</span></div>
          <div class="flexAlign"><span
              style="color: #2d8cf0; cursor: pointer; margin-right: 10px"
              @click="updateFlow(item)"
          >编辑</span
          >
            <span style="color: red; cursor: pointer;margin-right: 10px"
                  @click="stopFlow(item,1)"
            >停用</span
            ></div>
        </div>
      </div>
      <div style="padding-top: 30px">
        <div style="border-bottom: 1px solid #e4e4e4;font-weight: 600"><span>已停用</span></div>
        <div v-for="item in stopData" :key="item.id">
          <div style="display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #e4e4e4;">
            <div class="flexAlign" style="width: 20%"><img src="~assets/images/common/icon_user.png" width="50px"/><span
                style="padding-left: 10px">{{ item.flowName }}</span></div>
            <div class="flexAlign" style="flex-direction: column;width: 20%">
              <span>最后修改人：</span><span>{{ item.updateUser }}</span></div>
            <div class="flexAlign" style="flex-direction: column;width: 40%">
              <span>最后更新：</span><span>{{ item.updateTime | timeFormatDate }}</span></div>
            <div class="flexAlign"><span
                style="color: #2d8cf0; cursor: pointer; margin-right: 10px"
                @click="updateFlow(item)"
            >编辑</span
            >
              <span style="color: #67c23a; cursor: pointer;margin-right: 10px"
                    @click="stopFlow(item,0)"
              >启用</span
              ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import Vue from "vue";
import auth from "@/utils/auth";


export default {
  props: {
    userId: Number,
  },
  data() {
    return {
      stopData: [],
      activeData: [],
    };
  },
  watch: {
    $route(to, from) {
      console.log(from.path);//从哪来
      console.log(to.path);//到哪去
      this.getList()
    }
  },
  filters: {},
  created() {

  },
  mounted() {
    this.getList();
    this.getListTwo();
  },
  methods: {
    async getList() {
      this.loading = true;
      var obj = {
        isActive: 0
      }
      let res = await $api.flowTemplet.request(
          "queryFlowList",
          obj
      );
      if (res.status == 1) {
        this.activeData = res.data;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        this.loading = false;
      }
    },
    async getListTwo() {
      this.loading = true;
      var obj = {
        isActive: 1
      }
      let res = await $api.flowTemplet.request(
          "queryFlowList",
          obj
      );
      if (res.status == 1) {
        this.stopData = res.data;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        this.loading = false;
      }
    },
    async updateFlow(row) {
      this.loading = true;
      var obj = {
        id: row.id
      }
      let res = await $api.flowTemplet.request(
          "queryFlow",
          obj
      );
      if (res.status == 1) {
        localStorage.setItem('queryFlowData', JSON.stringify(res.data))
        this.$router.push({
          path: '/procedure/editFlow',
          name: '审批编辑',
          params: {
            queryFlowData: JSON.stringify(res.data),//对象转为字符串
          }
        })
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        this.loading = false;
      }
    },
    stopFlow(row, val) {
      var mes = '';
      if (val == 1) {
        mes = "停用"
      } else {
        mes = "启用"
      }
      this.$XModal.confirm("您确定" + mes + "该数据吗？").then((type) => {
        if (type === "confirm") {
          this.stopFlowCommit(row, val);
        }
      });
    },
    async stopFlowCommit(row, type) {
      this.loading = true;
      var obj = {
        id: row.id,
        isActive: type
      }
      let res = await $api.flowTemplet.request(
          "startAndStop",
          obj
      );
      if (res.status == 1) {
        this.$Message["success"]({
          background: true,
          content: "操作成功",
        });
        this.getList();
        this.getListTwo();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.flexAlign {
  display: flex;
  align-items: center;
}
</style>